import { VipCredit } from '@bz/wallet';

export const route = {
  info: {
    login: true,
  },
} satisfies RouteDefinition;
export default VipCredit;
